import type { SVGProps } from 'react';
const SvgLuggage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#luggage_svg__a)">
      <path
        fill="currentColor"
        d="M17 6h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2ZM9.5 18H8V9h1.5v9Zm3.25 0h-1.5V9h1.5v9Zm.75-12h-3V3.5h3V6ZM16 18h-1.5V9H16v9Z"
      />
    </g>
    <defs>
      <clipPath id="luggage_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLuggage;
